import { mdmsCountriesList } from '../redux-store/types/mdms';

export function validateTin(
  tinVal: string,
  countryOrNationality: string,
  countries: mdmsCountriesList[]
): boolean {
  if (!countryOrNationality || !tinVal) {
    return true;
  }
  const panRegex = countries.find((_country) =>
    [_country.name, _country.nationality].includes(countryOrNationality)
  )?.panRegex as string;
  if (!panRegex) {
    return true;
  }
  const regex = new RegExp(panRegex);
  return (tinVal && regex.test(tinVal.toLocaleLowerCase())) as boolean;
}
